import { Injectable } from '@angular/core';

import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DuplicatedDataCollections } from '@osos/shared/api';
import { DuplicatedCollectionPresenterModel } from '@osos/shared/types';
import { DuplicatedCollectionParserV1Service } from '../../parsers/lov-parser/duplicated-collection-parser-v1.service';

@Injectable()
export class DuplicatedCollectionFactoryService extends FactoryBase<
  DuplicatedDataCollections,
  DuplicatedCollectionPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DuplicatedCollectionParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: DuplicatedCollectionPresenterModel,
  ): DuplicatedDataCollections {
    const parser = this.getParser(
      DuplicatedDataCollections,
      DuplicatedCollectionPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: DuplicatedDataCollections | any,
  ): DuplicatedCollectionPresenterModel {
    throw new Error('Method not implemented');
  }
}
